
import React from 'react';
import { motion } from 'framer-motion';
import Footer from '../../../components/Footer';
import {
    MonitorPlay,
    Building,
    Wrench,
    Rocket,
    Stars,
    Briefcase,
    GraduationCap,
    ChevronRight, BookOpen,
    Award, Users, Globe,
    Clock, Bookmark, Share2, ArrowUpRight,
    Target, // for Vision
    Flag, // for Mission
    HelpCircle, // for Why Study
    Award as UniqueIcon // for What Makes Unique

} from 'lucide-react';
import { Link } from 'react-router-dom';
import Title from '../../../components/TitleComponent';

const Departments = [
    {
        name: "Department of Psychology",
        path: "/programmes/ug-courses/Arts-and-humanities/department-of-psychology"
    },
    {
        name: "Department of Sociology ",
        path: "/programmes/ug-courses/Arts-and-humanities/department-of-Sociology "
    },
    {
        name: "Department of English",
        path: "/programmes/ug-courses/Arts-and-humanities/department-of-English"
    },
    {
        name: "Department of Hindi",
        path: "/programmes/ug-courses/Arts-and-humanities/department-of-Hindi"
    },
    {
        name: "Department of Political Science ",
        path: "/programmes/ug-courses/Arts-and-humanities/department-of-Political-Science "
    },
    {
        name: "Department of Earth Science",
        path: "/programmes/ug-courses/Arts-and-humanities/department-of-Earth-Science"
    },
    {
        name: "Department of Yogic Science",
        path: "/programmes/ug-courses/Arts-and-humanities/department-of-Yogic-Science"
    },
    {
        name: "Department of Arts",
        path: "/programmes/ug-courses/Arts-and-humanities/department-of-Arts"
    },


]

// const undergraduatePrograms = [

//     {
//         name: "Bachelor of Technology in Cloud Computing and Engineering",
//         path: "/programmes/ug-courses/engineering/btech/cloud-computing-engineering"
//     },
//     {
//         name: "Bachelor of Technology in Data Science and Engineering",
//         path: "/programmes/ug-courses/engineering/btech/data-science-engineering"
//     },
//     {
//         name: "Bachelor of Technology in Cyber Security and Engineering",
//         path: "/programmes/ug-courses/engineering/btech/cybersecurity-engineering"
//     },
//     {
//         name: "Bachelor of Technology in Artificial Intelligence Machine Learning and Engineering",
//         path: "/programmes/ug-courses/engineering/btech/ai-ml"
//     },
//     {
//         name: "Bachelor of Technology in Civil Engineering",
//         path: "/programmes/ug-courses/engineering/btech/civil-engineering"
//     },
//     {
//         name: "Bachelor of Technology in Computer Science and Engineering",
//         path: "/programmes/ug-courses/engineering/btech/computer-science-engineering"
//     },
//     {
//         name: "Bachelor of Technology in Mechanical Engineering",
//         path: "/programmes/ug-courses/engineering/btech/mechanical-engineering"
//     },
//     // {
//     //     name: "Bachelor of Technology in Mechatronics and Robotics",
//     //     path: "/programmes/ug-courses/engineering/btech/mechatronics-and-robotics"
//     // },
// ]

// const PostgraduatePrograms = [
//     {
//         name: "Master of Technology in Thermal Engineering",
//         path: "/programmes/pg-courses/engineering/mtech/thermal-engineering"
//     },
//     {
//         name: "Master of Technology in Production Engineering",
//         path: "/programmes/pg-courses/engineering/mtech/production-engineering"
//     },
//     {
//         name: "Master of Technology in Renewable Energy",
//         path: "/programmes/pg-courses/engineering/mtech/renewable-energy"
//     },
//     // {
//     //     name: "Master of Technology in Electric Vehicle  Technology",
//     //     path: "/programmes/pg-courses/engineering/mtech/electric-vehicle"
//     // },
//     {
//         name: "Master of Technology in Structural Engineering",
//         path: "/programmes/pg-courses/engineering/mtech/structural-engineering"
//     },
//     {
//         name: "Master of Technology in Transportation Engineering",
//         path: "/programmes/pg-courses/engineering/mtech/transportation-engineering"
//     },
//     // {
//     //     name: "Master of Technology in Data Science and Engineering",
//     //     path: "/programmes/pg-courses/engineering/mtech/data-science-engineering"
//     // },
//     // {
//     //     name: "Master of Technology in Artificial Intelligence Machine Learning and Engineering",
//     //     path: "/programmes/pg-courses/engineering/mtech/ai-ml"
//     // },
//     {
//         name: "Master of Technology in Digital Communication Engineering",
//         path: "/programmes/pg-courses/engineering/mtech/digital-communication"
//     },

// ]



const Stats = () => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 my-4 md:my-8 px-4"
    >
        {[
            { icon: <Users className="w-6 h-6 md:w-8 md:h-8" />, number: "5000+", label: "Students Enrolled", color: "bg-blue-50" },
            { icon: <BookOpen className="w-6 h-6 md:w-8 md:h-8" />, number: "50+", label: "Programs Offered", color: "bg-green-50" },
            { icon: <Award className="w-6 h-6 md:w-8 md:h-8" />, number: "95%", label: "Placement Rate", color: "bg-purple-50" },
            { icon: <Globe className="w-6 h-6 md:w-8 md:h-8" />, number: "100+", label: "Industry Partners", color: "bg-orange-50" }
        ].map((stat, index) => (
            <motion.div
                key={index}
                className={`${stat.color} p-4 rounded-xl shadow-md hover:shadow-xl transition-all duration-300`}
                whileHover={{ scale: 1.02 }}
            >
                <div className="text-[#0e4d38]">{stat.icon}</div>
                <h3 className="text-xl md:text-2xl font-bold mt-2 text-gray-800">{stat.number}</h3>
                <p className="text-gray-600 text-xs md:text-sm">{stat.label}</p>
            </motion.div>
        ))}
    </motion.div>
);


const AboutSection = () => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-3 mb-4 border-b pb-4">
            <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                <BookOpen className="w-6 h-6" />
            </div>
            <h4 className="text-xl font-semibold text-[#0e4d38]">School of Arts and Humanities </h4>
        </div>
        <div className="space-y-4 text-gray-700">
            <p>The School of Arts and Humanities is a dynamic academic school of education dedicated to offering a wide range of disciplines, all focusing on the in-depth study of human culture, creativity, intellectual pursuits, and the diverse ways in which people engage with the world around them. This school serves as a foundation for understanding the complexities of human expression, societal dynamics, and historical developments. It encompasses a broad array of subjects, including literature Hindi/English, History, Sociology, Psychology/clinical psychology, Geography and political science etc.  </p>

            <p>Through this wide range of disciplines, the School of Arts and Humanities provides students with a well-rounded, interdisciplinary education that nurtures intellectual curiosity and a lifelong love of learning. It encourages students to think critically, creatively, and empathetically, preparing them for careers that demand problem-solving abilities, cultural awareness, and strong communication skills. Whether pursuing research, teaching, or creative careers, graduates from this field gain valuable insights into the human experience, which can be applied in a variety of professional surroundings.</p>

            <p>School of Arts and Humanities focuses on enhancing communication skills and personality development. It organizes seminars, workshops, debates, and lectures, while also providing a platform for research students striving for excellence.
            </p>
            <p>On a global level, the scope for Arts and Humanities graduates is vast. These fields prepare individuals for careers in education, media, publishing, research, government, and international organizations. The global demand for cultural understanding, creative expression, and critical thought ensures disciplines, from these programs have a wide range of opportunities worldwide.
            </p>
        </div>
    </motion.div>
);

// const VisionMissionSection = () => (
//     <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//         <motion.div
//             initial={{ opacity: 0, x: -20 }}
//             whileInView={{ opacity: 1, x: 0 }}
//             viewport={{ once: true }}
//             className="bg-white p-6 rounded-xl shadow-lg"
//         >
//             <div className="flex items-center gap-3 mb-4 border-b pb-4">
//                 <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
//                     <Target className="w-6 h-6" />
//                 </div>
//                 <h4 className="text-xl font-semibold text-[#0e4d38]">Vision</h4>
//             </div>
//             <ul className="space-y-3 text-gray-700">
//                 <li className="flex items-start gap-2">
//                     <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
//                     <span>To develop highly skilled professionals to man positions in the industry responding to technological and scientific advancements.</span>
//                 </li>
//                 <li className="flex items-start gap-2">
//                     <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
//                     <span>To be a premier institution of technical education and research, producing globally competent engineers who are innovative, ethical, and socially responsible, driving technological advancement and contributing to the sustainable development of society. </span>
//                 </li>
//             </ul>
//         </motion.div>

//         <motion.div
//             initial={{ opacity: 0, x: 20 }}
//             whileInView={{ opacity: 1, x: 0 }}
//             viewport={{ once: true }}
//             className="bg-white p-6 rounded-xl shadow-lg"
//         >
//             <div className="flex items-center gap-3 mb-4 border-b pb-4">
//                 <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
//                     <Flag className="w-6 h-6" />
//                 </div>
//                 <h4 className="text-xl font-semibold text-[#0e4d38]">Mission</h4>
//             </div>
//             <ul className="space-y-3 text-gray-700">
//                 <li className="flex items-start gap-2">
//                     <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
//                     <span>To develop highly skilled professionals to man positions in the industry responding to technological and scientific advancements.</span>
//                 </li>
//                 <li className="flex items-start gap-2">
//                     <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
//                     <span>To impart quality technical education, foster research and innovation, and nurture skilled engineers who can address global challenges and contribute to the progress of society.</span>
//                 </li>
//             </ul>
//         </motion.div>
//     </div>
// );


// const WhySection = () => (
//     <motion.div
//         initial={{ opacity: 0, y: 20 }}
//         whileInView={{ opacity: 1, y: 0 }}
//         viewport={{ once: true }}
//         className="bg-white p-6 rounded-xl shadow-lg"
//     >
//         <div className="flex items-center gap-3 mb-4 border-b pb-4">
//             <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
//                 <BookOpen className="w-6 h-6" />
//             </div>
//             <h4 className="text-xl font-semibold text-[#0e4d38]">Why Study Engineering & Technology? </h4>
//         </div>
//         <div className="space-y-4 text-gray-700">
//             <p>Engineering offers a diverse range of programs that are applicable in various fields, ensuring strong career prospects and high job satisfaction.
//                 These programs cater to the academic aspirations of engineering students and provide practical knowledge that can be applied across numerous industries.
//             </p>

//             <p>The 21st century is marked by rapid innovation, and exposure to engineering allows students to stay at the forefront of modern technological trends. Engineering plays a vital role in solving real-world problems, offering practical solutions that address the needs of society. As long as humanity continues to evolve, the demand for skilled engineers remains essential.  </p>

//             <p>Upon graduation, engineers have access to a broad spectrum of career opportunities, whether in traditional engineering roles or in entrepreneurial ventures, enabling them to innovate and contribute to society in multiple  ways.
//             </p>
//         </div>
//     </motion.div>
// );
// const WhatSection = () => (
//     <motion.div
//         initial={{ opacity: 0, x: 20 }}
//         whileInView={{ opacity: 1, x: 0 }}
//         viewport={{ once: true }}
//         className="bg-white p-6 rounded-xl shadow-lg"
//     >
//         <div className="flex items-center gap-3 mb-4 border-b pb-4">
//             <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
//                 <Flag className="w-6 h-6" />
//             </div>
//             <h4 className="text-xl font-semibold text-[#0e4d38]">What makes School of Engineering at Maya Devi University unique? </h4>
//         </div>
//         <ul className="space-y-3 text-gray-700">
//             <li className="flex items-start gap-2">
//                 <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
//                 <span>The Faculty of Engineering offers a range of programs that incorporate cutting-edge techniques, providing students with a comprehensive engineering education. </span>
//             </li>
//             <li className="flex items-start gap-2">
//                 <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
//                 <span>We prioritize systematic evaluation and feedback to support continuous learning and improvement. </span>
//             </li>
//             <li className="flex items-start gap-2">
//                 <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
//                 <span>To inspire and motivate students, the faculty creates various platforms where they can cultivate their creativity and innovation. </span>
//             </li>
//             <li className="flex items-start gap-2">
//                 <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
//                 <span>Additionally, our strategic international partnerships offer students valuable opportunities for global exposure and participation  in collaborative research projects with leading institutions.  </span>
//             </li>
//         </ul>
//     </motion.div>
// );


const CourseCard = ({ course, index }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: index * 0.1 }}
        className="group w-full"
    >
        <Link to={course.path}>
            <div className="bg-white p-3 md:p-4 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 h-full flex flex-col justify-between gap-2 md:gap-3">
                <div>
                    <div className="flex justify-between items-start">
                        <div className="p-2 bg-blue-50 rounded-lg">
                            <GraduationCap className="w-4 h-4 md:w-5 md:h-5 text-blue-600" />
                        </div>
                        <motion.div
                            whileHover={{ scale: 1.1 }}
                            className="p-1 md:p-2 rounded-full hover:bg-gray-100"
                        >
                            <ArrowUpRight className="w-3 h-3 md:w-4 md:h-4 text-gray-400 group-hover:text-[#0e4d38]" />
                        </motion.div>
                    </div>
                    <h3 className="text-sm md:text-lg font-semibold mt-2 md:mt-3 text-gray-800 group-hover:text-[#0e4d38] transition-colors line-clamp-2">
                        {course.name}
                    </h3>
                </div>
                <div className="flex items-center gap-2 md:gap-3 text-xs text-gray-500">
                    <div className="flex items-center gap-1">
                        <Clock className="w-3 h-3" />
                        <span>{course.name.includes('Master') ? '2 Years' : '4 Years'}</span>
                    </div>
                    <div className="flex items-center gap-1">
                        <Bookmark className="w-3 h-3" />
                        <span>{course.name.includes('Master') ? 'PG' : 'UG'}</span>
                    </div>
                </div>
            </div>
        </Link>
    </motion.div>
);

const Department = ({ title, icon, courses }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-4 md:p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6 border-b pb-4">
            <div className="p-2 md:p-3 bg-[#0e4d38] rounded-lg text-white">
                {icon}
            </div>
            <h4 className="text-lg md:text-xl font-semibold text-[#0e4d38]">{title}</h4>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-4">
            {courses.map((course, index) => (
                <CourseCard key={index} course={course} index={index} />
            ))}
        </div>
    </motion.div>
);

const FeatureList = ({ title, items, icon }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-4 md:p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6 border-b pb-4">
            <div className="p-2 md:p-3 bg-[#0e4d38] rounded-xl text-white">
                {icon}
            </div>
            <h4 className="text-lg md:text-xl font-semibold text-[#0e4d38]">{title}</h4>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-4">
            {items.map((item, index) => (
                <motion.div
                    key={index}
                    className="p-3 rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors duration-300"
                    whileHover={{ scale: 1.02 }}
                >
                    <div className="flex items-start gap-2">
                        <div className="w-2 h-2 mt-1.5 bg-[#23376c] rounded-full flex-shrink-0" />
                        <span className="text-gray-700 text-xs md:text-sm">{item}</span>
                    </div>
                </motion.div>
            ))}
        </div>
    </motion.div>
);

const HeroSection = () => (
    <div className="relative overflow-hidden bg-[#0e4d38] text-white py-8 md:py-16 px-4 md:px-6 rounded-xl mb-6 md:mb-8 mt-16 md:mt-20">
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-5xl"
        >
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-3 md:mb-4">
                School of Arts and Humanities (M.D.U)
            </h1>
            <p className="text-sm md:text-lg text-gray-200 mb-4 md:mb-6 max-w-3xl">
                The School of Arts and Humanities is a dynamic academic school of education dedicated to offering a wide range of disciplines, all focusing on the in-depth study of human culture, creativity, intellectual pursuits, and the diverse ways in which people engage with the world around them.
            </p>
            <Link to="https://admission.maya.edu.in/">
                <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="bg-white text-[#0e4d38] px-4 md:px-6 py-2 md:py-3 rounded-full text-sm md:text-base font-semibold flex items-center gap-2 group"
                >
                    Apply Now
                    <Rocket className="w-3 h-3 md:w-4 md:h-4 group-hover:translate-x-1 transition-transform" />
                </motion.button>
            </Link>
        </motion.div>
    </div>
);

const ArtsAndHumanities = () => {
    return (
        <div className="min-h-screen bg-gray-50 font-poppins">
            <Title canonicalPath="/programmes/ugcourses/Arts-and-humanities/" />
            <Title title="Best Arts and Humanities College in Dehradun, Uttarakhand" description=" Maya Devi University is one of the best Arts and Humanities University in Dehradun, offering world-class engineering programs in different Branches." />
            <div className="max-w-7xl mx-auto pt-16 md:pt-20 pb-8 md:pb-16 px-4 space-y-6 md:space-y-8">
                <HeroSection />
                <Stats />
                <AboutSection />
                {/* <WhySection />
                <WhatSection /> */}
                {/* <VisionMissionSection /> */}
                <div className="space-y-6 md:space-y-8">
                    <Department
                        title="Departments"
                        icon={<MonitorPlay className="w-5 h-5 md:w-6 md:h-6" />}
                        courses={Departments}
                    />
                    {/* <Department
                        title="Undergraduate Programs"
                        icon={<Building className="w-5 h-5 md:w-6 md:h-6" />}
                        courses={undergraduatePrograms}
                    />
                    <Department
                        title="Postgraduate Programs"
                        icon={<Wrench className="w-5 h-5 md:w-6 md:h-6" />}
                        courses={PostgraduatePrograms}
                    /> */}
                </div>

                {/* <div className="space-y-6 md:space-y-8">
                    <FeatureList
                        title="USPs"
                        icon={<Stars className="w-6 h-6 text-[#0e4d38]" />}
                        items={[
                            "Industry-Relevant Curriculum designed by Core Academia & Renowned Industry Experts",
                            "Renowned Domain Specific & Highly Rich Experienced Faculty",
                            "State-of-the-art infrastructure including computer labs",
                            "Centre of Excellence in Specific Domain & Technology",
                            "Continuous learning and skill enhancement",
                            "Hands-On Learning through practical projects",
                            "Live Industry Projects based Learning",
                            "Global Recognition and accreditation",
                            "LMS based Pedagogy",
                            "Choice Based Credit System (CBCS)",
                            "Industry Collaborations and Internships",
                            "Full-Time Industrial Internship",
                            "Entrepreneurship programs and incubation centres"
                        ]}
                    />

                    <FeatureList
                        title="Career Options"
                        icon={<Briefcase className="w-6 h-6 text-[#0e4d38]" />}
                        items={[
                            "Cloud Computing Specialist",
                            "Data Scientist/Data Analyst",
                            "AI/ML Engineer",
                            "Cybersecurity Analyst",
                            "Software Developer",
                            "Database Administrator",
                            "Network Engineer",
                            "IT Consultant",
                            "Systems Analyst",
                            "Web Developer",
                            "Software Engineer"
                        ]}
                    />
                </div> */}
            </div>
            <Footer />
        </div>
    );
};

export default ArtsAndHumanities;